import { render, staticRenderFns } from "./BatchOfRemittance.vue?vue&type=template&id=7a85b1be&scoped=true&"
import script from "./BatchOfRemittance.vue?vue&type=script&lang=js&"
export * from "./BatchOfRemittance.vue?vue&type=script&lang=js&"
import style0 from "./BatchOfRemittance.vue?vue&type=style&index=0&id=7a85b1be&lang=less&scoped=true&"
import style1 from "./BatchOfRemittance.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a85b1be",
  null
  
)

export default component.exports